.youtube {
  position: relative;
  z-index: 1;
  padding: 0;
  font-family: var(--token-font-ui);
  color: var(--token-text-primary);
  flex: 1;
  min-height: 100%;
  width: 100%;
  display: flex;
  align-items: stretch;
}

.empty {
  position: relative;
  z-index: 1;
  padding: var(--token-space-2xl);
  font-family: var(--token-font-ui);
}

.shell {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: var(--token-space-lg);
  min-height: 0;
}

.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--token-space-lg);
  padding: var(--token-space-lg) var(--token-space-xl);
  border-radius: var(--token-radius-card);
  border: 1.5px solid var(--token-accent);
  background: rgba(255, 250, 240, 0.62);
  backdrop-filter: blur(22px) saturate(160%);
  -webkit-backdrop-filter: blur(22px) saturate(160%);
  box-shadow:
    0 30px 60px -20px rgba(8, 18, 12, 0.35),
    inset 0 1px 0 rgba(255, 255, 255, 0.45);
}

.title {
  margin: 0;
  font-family: var(--token-font-display);
  font-size: clamp(30px, 3vw, 54px);
  line-height: 1;
  color: var(--token-accent);
}

.subtitle {
  margin: var(--token-space-xs) 0 0;
  font-family: var(--token-font-body);
  color: rgba(28, 38, 32, 0.68);
}

.actions {
  display: flex;
  flex-wrap: wrap;
  gap: var(--token-space-sm);
  justify-content: flex-end;
}

.actionButton,
.playerButton {
  min-height: var(--token-touch-min);
  padding: var(--token-space-sm) var(--token-space-xl);
  border-radius: var(--token-radius-pill);
  border: 1.5px solid color-mix(in srgb, var(--token-accent) 55%, transparent);
  background: var(--token-accent);
  color: var(--token-card-bg);
  font-family: var(--token-font-ui);
  font-weight: 800;
  cursor: pointer;
}

.actionButton:disabled,
.playerButton:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.notice {
  margin: 0;
  padding: var(--token-space-2xl);
  border-radius: var(--token-radius-card);
  background: rgba(255, 250, 240, 0.68);
  border: 1.5px solid color-mix(in srgb, var(--token-accent) 35%, transparent);
  font-size: clamp(18px, 1.7vw, 28px);
  text-align: center;
}

.grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  gap: var(--token-space-lg);
  overflow: auto;
  padding: 2px;
  min-height: 0;
}

.card {
  min-width: 0;
  overflow: hidden;
  border-radius: var(--token-radius-card);
  border: 1.5px solid var(--token-accent);
  background: rgba(255, 250, 240, 0.74);
  box-shadow:
    0 24px 46px -22px rgba(8, 18, 12, 0.5),
    inset 0 1px 0 rgba(255, 255, 255, 0.45);
}

.thumbButton {
  position: relative;
  display: block;
  width: 100%;
  aspect-ratio: 16 / 9;
  max-height: min(32vh, 320px);
  padding: 0;
  border: 0;
  background: rgba(28, 38, 32, 0.12);
  cursor: pointer;
}

.thumb {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.playBadge {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  min-height: var(--token-touch-min);
  display: inline-flex;
  align-items: center;
  padding: var(--token-space-sm) var(--token-space-xl);
  border-radius: var(--token-radius-pill);
  background: var(--token-accent);
  color: var(--token-card-bg);
  font-weight: 900;
  box-shadow: 0 12px 28px rgba(8, 18, 12, 0.3);
}

.cardText {
  padding: var(--token-space-lg);
}

.cardText h2 {
  margin: 0;
  font-family: var(--token-font-ui);
  font-size: clamp(18px, 1.5vw, 28px);
  line-height: 1.18;
}

.cardText p {
  margin: var(--token-space-xs) 0 0;
  color: rgba(28, 38, 32, 0.66);
  font-family: var(--token-font-body);
  font-size: clamp(14px, 1vw, 18px);
}

.played {
  border-radius: var(--token-radius-card-inner);
  background: rgba(255, 255, 255, 0.48);
  padding: var(--token-space-sm) var(--token-space-md);
  width: min(620px, 100%);
}

@media (max-height: 760px) {
  .shell {
    gap: var(--token-space-sm);
  }

  .header {
    padding: var(--token-space-md) var(--token-space-lg);
  }

  .grid {
    gap: var(--token-space-sm);
  }

  .cardText {
    padding: var(--token-space-sm) var(--token-space-md);
  }

  .thumbButton {
    max-height: 260px;
  }
}

.played summary {
  cursor: pointer;
  font-weight: 800;
  font-size: clamp(16px, 1.2vw, 22px);
}

.playedList {
  display: flex;
  flex-direction: column;
  gap: var(--token-space-xs);
  padding-top: var(--token-space-sm);
}

.playedButton {
  min-height: var(--token-touch-min);
  display: grid;
  grid-template-columns: 72px minmax(0, 1fr);
  align-items: center;
  gap: var(--token-space-sm);
  width: 100%;
  padding: var(--token-space-xs);
  border-radius: var(--token-radius-card-inner);
  border: 1px solid rgba(28, 38, 32, 0.16);
  background: rgba(255, 255, 255, 0.72);
  color: var(--token-text-primary);
  font-family: var(--token-font-ui);
  text-align: left;
  cursor: pointer;
}

.playedThumb {
  width: 72px;
  aspect-ratio: 16 / 9;
  border-radius: 8px;
  object-fit: cover;
  background: rgba(28, 38, 32, 0.1);
}

.playedText {
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.playedText strong,
.playedText span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.playedText strong {
  font-size: clamp(13px, 0.95vw, 17px);
  line-height: 1.2;
}

.playedText span {
  color: rgba(28, 38, 32, 0.62);
  font-family: var(--token-font-body);
  font-size: clamp(11px, 0.8vw, 14px);
}

.overlay {
  position: fixed;
  z-index: 20;
  inset: 0;
  display: flex;
  flex-direction: column;
  gap: var(--token-space-lg);
  padding: var(--token-space-xl);
  background: rgba(8, 18, 12, 0.92);
  color: var(--token-card-bg);
}

.playerHeader {
  display: grid;
  grid-template-columns: auto minmax(0, 1fr) auto;
  gap: var(--token-space-lg);
  align-items: center;
}

.playerTitle {
  min-width: 0;
  display: flex;
  flex-direction: column;
  text-align: center;
}

.playerTitle strong,
.playerTitle span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.playerTitle strong {
  font-size: clamp(18px, 1.6vw, 30px);
}

.playerTitle span {
  opacity: 0.72;
}

.playerFrame {
  position: relative;
  flex: 1;
  min-height: 0;
  aspect-ratio: 16 / 9;
  max-height: calc(100vh - 112px);
  margin: 0 auto;
  width: 100%;
  border-radius: var(--token-radius-card-inner);
  overflow: hidden;
  background: rgba(0, 0, 0, 1);
}

.posterFrame {
  aspect-ratio: auto;
  max-width: min(100%, 1500px);
}

.iframeMount,
.playerFrame iframe {
  width: 100%;
  height: 100%;
  display: block;
  border: 0;
}

.iframeMount iframe {
  width: 100%;
  height: 100%;
  display: block;
  border: 0;
}

.posterButton {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 0;
  border: 0;
  background: rgba(0, 0, 0, 1);
  color: var(--token-card-bg);
  cursor: pointer;
  overflow: hidden;
  text-align: left;
}

.posterMedia {
  position: relative;
  display: block;
  flex: 1;
  min-height: 0;
  width: 100%;
  background: rgba(0, 0, 0, 1);
}

.posterImage {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.posterShade {
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.42);
}

.posterText {
  display: flex;
  flex-direction: column;
  gap: var(--token-space-xs);
  padding: var(--token-space-lg) var(--token-space-2xl) var(--token-space-xl);
  background: rgba(0, 0, 0, 0.94);
}

.posterText strong {
  font-family: var(--token-font-ui);
  font-size: clamp(24px, 2.4vw, 44px);
  line-height: 1.12;
}

.posterText span {
  font-family: var(--token-font-ui);
  font-size: clamp(15px, 1.1vw, 22px);
  opacity: 0.78;
}

.posterPlay {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  min-height: var(--token-touch-min);
  display: inline-flex;
  align-items: center;
  padding: var(--token-space-md) var(--token-space-2xl);
  border-radius: var(--token-radius-pill);
  background: var(--token-accent);
  color: var(--token-card-bg);
  font-family: var(--token-font-ui);
  font-weight: 900;
  font-size: clamp(18px, 1.6vw, 30px);
  box-shadow: 0 18px 40px rgba(0, 0, 0, 0.42);
}

@media (max-width: 760px) {
  .header,
  .playerHeader {
    align-items: stretch;
    grid-template-columns: 1fr;
  }

  .header {
    flex-direction: column;
  }
}
